import React, { useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from "primereact/dialog";
import { Button, Field, Form } from "@bwevents/components";
import "./Account.scss";
import InputPassword from "../InputPassword";
import { Link, useNavigate } from "react-router-dom";
import { Helpers } from "../../services/Helpers";

export default function Account({ account, setAccount, api, messenger }) {
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState(account.accept_newsletter);

  const [dialogName, setDialogName] = useState(false);
  const [firstName, setFirstName] = useState(account.first_name);
  const [lastName, setLastName] = useState(account.last_name);

  const [dialogCurrentPassword, setDialogCurrentPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState();
  const [currentPasswordValid, setCurrentPasswordValid] = useState(false);

  const [dialogDeleteAccount, setDialogDeleteAccount] = useState(false);

  const [dialogNewPassword, setDialogNewPassword] = useState(false);
  const [password, setPassword] = useState();
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState();
  const [passwordConfirmValid, setPasswordConfirmValid] = useState(false);

  const formValidName = firstName && lastName;
  const formValidCurrentPassword = currentPasswordValid;
  const formValidNewPassword = passwordValid && passwordConfirmValid;

  const getCurrentPassword = (e) => {
    setCurrentPassword(e);
  };
  const currentPasswordIsValid = (e) => {
    setCurrentPasswordValid(e);
  };

  const getPassword = (e) => {
    setPassword(e);
  };
  const passwordIsValid = (e) => {
    setPasswordValid(e);
  };
  const getPasswordConfirm = (e) => {
    setPasswordConfirm(e);
  };
  const passwordConfirmIsValid = (e) => {
    setPasswordConfirmValid(e);
  };

  const handleApi = (obj, message) => {
    api(`api/providers/${process.env.REACT_APP_SLUG}/users/my_profile/`, {
      method: "PATCH",
      ignoreError: true,
      body: {
        ...obj,
      },
    }).then(({ ok }) => {
      if (ok) {
        messenger({
          severity: "success",
          detail: message,
          life: 3000,
        });
        api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`).then(
          ({ body }) => {
            setAccount(body?.data);
          },
        );
      } else {
        messenger({
          severity: "error",
          detail: "Unable to update, please try again..",
          life: 3000,
        });
      }
    });
  };
  const handleSubmitName = () => {
    const obj = {
      first_name: firstName,
      last_name: lastName,
    };
    handleApi(obj, "Name successfully changed");
    setDialogName(false);
  };
  const handleSubmitCurrentPassword = () => {
    setDialogCurrentPassword(false);
    setDialogNewPassword(true);
  };
  const handleNewPassword = () => {
    const obj = {
      current_password: currentPassword,
      password: password,
      password_repeat: passwordConfirm,
    };
    api(`api/auth/replace/`, {
      method: "POST",
      ignoreError: true,
      ignoreNotFound: true,
      body: {
        ...obj,
      },
    })
      .then(({ ok }) => {
        if (ok) {
          messenger({
            severity: "success",
            detail: "Password successfully changed.",
            life: 3000,
          });
          api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`).then(
            ({ body }) => {
              setAccount(body?.data);
            },
          );
        } 
      })
      .finally(() => {
        setDialogNewPassword(false);
      });
  };
  const handleNotifications = (e) => {
    setNotifications(e.value);
    const obj = {
      accept_newsletter: e.value,
    };
    handleApi(obj, "Notifications successfully changed");
  };
  const handleDeleteAccount = () => {
    setDialogDeleteAccount(false);
    api(`api/providers/${process.env.REACT_APP_SLUG}/users/remove/`, {
      method: "DELETE",
    }).then(({ ok }) => {
      if (ok) {
        setAccount();
        navigate("/");
      }
    });
  };

  return (
    <div className="account-info">
      <div className="content">
        <div className="wrapper-info">
          <p>Full name</p>
          <div className="info">
            {firstName} {lastName}
          </div>
          <button className="bw-event-btn" onClick={() => setDialogName(true)}>
            Edit
          </button>
        </div>
        <div className="wrapper-info">
          <p>Email</p>
          <div className="info">{account.email}</div>
        </div>
        <div className="wrapper-info">
          <p>Password</p>
          <div className="info">
            Last changed{" "}
            {account.last_changed_password
              ? Helpers.dateMaskString(account.last_changed_password)
              : Helpers.dateMaskString(account.modified)}
          </div>
          <button
            className="bw-event-btn"
            onClick={() => setDialogCurrentPassword(true)}
          >
            Edit
          </button>
        </div>
        <div className="wrapper-info notifications">
          <p>Notifications</p>
          <div className="info">
            Receive newsletters, promotions and news from BW Events. No spam
          </div>
          <div className="bw-event-btn">
            <div className="bw-event-switch">
              <InputSwitch
                className="bw-event-switch-field"
                checked={notifications}
                onChange={(e) => handleNotifications(e)}
              />
            </div>
          </div>
        </div>
        <div className="wrapper-info">
          <p onClick={() => setDialogDeleteAccount(true)}>Delete account</p>
          <div className="info">
            Permanently delete your account and all of your data
          </div>
        </div>

        <Dialog
          header="Edit first & last name"
          className="bw-event-dialog"
          visible={dialogName}
          onHide={() => setDialogName(false)}
        >
          <Form>
            <Field
              type="text"
              label="First name"
              placeholder="First name"
              value={firstName}
              setValue={setFirstName}
              invalid={firstName === ""}
              invalidMessage="First name is required."
              className="bw-event-input"
            />
            <Field
              type="text"
              label="Last name"
              placeholder="Last name"
              value={lastName}
              setValue={setLastName}
              invalid={lastName === ""}
              invalidMessage="Last name is required."
              className="bw-event-input"
            />
            <div className="wrapper-btns">
              <button
                className="bw-event-btn cancel"
                onClick={() => setDialogName(false)}
              >
                Cancel
              </button>
              <Button
                className="bw-event-btn"
                label="Save"
                onClick={handleSubmitName}
                disabled={!formValidName}
              />
            </div>
          </Form>
        </Dialog>
        <Dialog
          header="To continue, verify it’s you"
          className="bw-event-dialog"
          visible={dialogCurrentPassword}
          onHide={() => setDialogCurrentPassword(false)}
        >
          <Form>
            <InputPassword
              label="Password"
              placeholder="Enter password"
              emmitValue={getCurrentPassword}
              emmitValid={currentPasswordIsValid}
            />
            <div className="flex justify-content-end mb-5">
              <Link to="/forgot-password" className="bw-event-link">
                Forgot password
              </Link>
            </div>
            <div className="wrapper-btns">
              <button
                className="bw-event-btn cancel"
                onClick={() => setDialogCurrentPassword(false)}
              >
                Cancel
              </button>
              <Button
                className="bw-event-btn"
                label="Continue"
                onClick={handleSubmitCurrentPassword}
                disabled={!formValidCurrentPassword}
              />
            </div>
          </Form>
        </Dialog>
        <Dialog
          header="Create a new password"
          className="bw-event-dialog"
          visible={dialogNewPassword}
          onHide={() => setDialogNewPassword(false)}
        >
          <Form>
            <InputPassword
              label="Password"
              placeholder="Enter password"
              emmitValue={getPassword}
              emmitValid={passwordIsValid}
            >
              <p className="bw-event-callout">
                6 to 20 symbols (A-Z, a-z, 0-9)
              </p>
            </InputPassword>
            <InputPassword
              label="Repeat password"
              placeholder="Enter password"
              equalTo={password}
              typeConfirm={true}
              forceInvalidConfirm={password !== passwordConfirm}
              emmitValue={getPasswordConfirm}
              emmitValid={passwordConfirmIsValid}
            />
            <div className="wrapper-btns">
              <button
                className="bw-event-btn cancel"
                onClick={() => setDialogNewPassword(false)}
              >
                Cancel
              </button>
              <Button
                className="bw-event-btn"
                label="Continue"
                onClick={handleNewPassword}
                disabled={!formValidNewPassword}
              />
            </div>
          </Form>
        </Dialog>
        <Dialog
          header="Delete account"
          className="bw-event-dialog"
          visible={dialogDeleteAccount}
          onHide={() => setDialogDeleteAccount(false)}
        >
          <p className="mb-5">
            Are you sure you want to delete your BW Events Account permanently?
            You won't be able to undo this action.
          </p>
          <div className="wrapper-btns">
            <button
              className="bw-event-btn cancel"
              onClick={() => setDialogDeleteAccount(false)}
            >
              Cancel
            </button>
            <Button
              className="bw-event-btn bw-event-btn-red"
              label="Yes, delete"
              onClick={handleDeleteAccount}
            />
          </div>
        </Dialog>
      </div>
    </div>
  );
}
